// extracted by mini-css-extract-plugin
export default {"container":"MarkdownRenderer-module__container--wIGWk"};